interface ClientTeamMemberDisplayData {
  firstName: string;
  lastName: string;
  semiUniqueIdentifier?: string | null;
  unknownGuest?: boolean | null;
}

export const buildClientTeamMemberDisplayName = (
  clientTeamMember: ClientTeamMemberDisplayData,
) => {
  const { lastName, firstName, semiUniqueIdentifier, unknownGuest } =
    clientTeamMember;

  // Trim and normalize the name fields
  const trimmedLastName = lastName?.trim() || '';
  const trimmedFirstName = firstName?.trim() || '';
  const trimmedIdentifier = semiUniqueIdentifier?.trim() || '';

  // Special case: Unknown Guest should display as "Unknown Guest" not "Guest, Unknown"
  if (unknownGuest) {
    return 'Unknown Guest';
  }

  // If no name fields at all, fall back to identifier or placeholder
  if (!trimmedLastName && !trimmedFirstName) {
    if (trimmedIdentifier) {
      return trimmedIdentifier;
    }
    return '(No Name)';
  }

  // Build the name portion
  const namePart =
    trimmedLastName && trimmedFirstName
      ? `${trimmedLastName}, ${trimmedFirstName}`
      : trimmedLastName || trimmedFirstName;

  // Add identifier prefix if present
  return trimmedIdentifier ? `${trimmedIdentifier} - ${namePart}` : namePart;
};
